import { createContext, useContext, useEffect, useState } from "react";
import { api, API } from "./api";

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = async () => {
    try {
      const { data } = await api.get("/site-settings");
      setSettings(data);
    } catch { /* noop */ }
    finally { setLoading(false); }
  };

  useEffect(() => { reload(); }, []);

  return (
    <SettingsCtx.Provider value={{ settings, loading, reload }}>
      {children}
    </SettingsCtx.Provider>
  );
}

export const useSettings = () => useContext(SettingsCtx);

// Resolve an image path — either object-storage or a full URL. Returns null if empty.
export function resolveImage(pathOrUrl, fallback) {
  if (!pathOrUrl) return fallback || null;
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) return pathOrUrl;
  return `${API}/media/public-image?path=${encodeURIComponent(pathOrUrl)}`;
}
